import { render, staticRenderFns } from "./RiderEfficiencyList.vue?vue&type=template&id=52fed275&scoped=true"
import script from "./RiderEfficiencyList.vue?vue&type=script&lang=js"
export * from "./RiderEfficiencyList.vue?vue&type=script&lang=js"
import style0 from "./RiderEfficiencyList.vue?vue&type=style&index=0&id=52fed275&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fed275",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52fed275')) {
      api.createRecord('52fed275', component.options)
    } else {
      api.reload('52fed275', component.options)
    }
    module.hot.accept("./RiderEfficiencyList.vue?vue&type=template&id=52fed275&scoped=true", function () {
      api.rerender('52fed275', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/DeliveryEffiRider/RiderEfficiencyList.vue"
export default component.exports